import { Toast } from "antd-mobile";
import { ApiCachedSecondsRandom } from "app/constant";
import CateBar from "components/dot/bar/cate-bar/index";
import Card from "components/dot/card/index";
// import Carousel from "components/skeleton/carousel";
import LoginForm from "components/skeleton/loginform/index";
import Slogan from "components/skeleton/slogan/index";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import UserApi from "services/apis/sys/user-api";
import UserDetailApi from "services/apis/usr/user-detail-api";
import VideoListApi from "services/apis/usr/video-list-api";
import { getItemWithExpiration, removeItem, setItemWithExpiration } from "utils/localStorageUtil";
import { scrollTop } from "utils/screenUtil";
import { useTranslation } from "react-i18next";
import { useI18n } from "i18n/useI18n";

export type UserLoginDataType = {
  username: string;
  password: string;
};

export default function Login() {
  const { t } = useI18n();
  const navigate = useNavigate();
  useEffect(() => {
    scrollTop();
  }, []);
  const [isLogin, toggleIsLogin] = useState(true);
  const [regSuccess, setRegSuccess] = useState(false);

  return (
    <>
      <div style={{ background: "#f5f5f5", paddingBottom: 10 }}>
        {/* <Carousel /> */}

        <CateBar />

        <div style={{ margin: 10 }}>
          <Card
            content={LoginForm({
              onFinish: (user: UserLoginDataType) => {
                const fetchUser = async (user: UserLoginDataType) => {
                  if (!isLogin) {
                    const result = await UserApi.register({
                      username: user.username,
                      password: user.password,
                    });
                    if (result.code === 0 && result.successful) {
                      Toast.show(t("login.index.863806-0"));
                      toggleIsLogin(true);
                      setRegSuccess(true);
                    } else {
                      Toast.show("{t('login.index.863806-1')} " + result.msg);
                    }
                    return;
                  }
                  const userResult = await UserApi.login({
                    username: user.username,
                    password: user.password,
                  });
                  if (userResult.code === 0 && userResult.successful) {
                    Toast.show(t("login.index.863806-2"));
                    const _userPolyInfo = userResult.result;
                    //设置登录用户
                    setItemWithExpiration("userPolyInfo", _userPolyInfo, ApiCachedSecondsRandom);
                    // const userDetailResult = await UserDetailApi.getByUserId(userResult.result.uuid);
                    // if (userDetailResult.code === 0 && userDetailResult.successful) {
                    //   setItemWithExpiration(
                    //     "vip",
                    //     { userGroupId: userDetailResult.result?.fkUserGroupUuid || 0 },
                    //     ApiCachedSecondsRandom
                    //   );
                    // }
                    // console.log(t('login.index.863806-2'), result.result);
                    //获取用户的视频列表(收藏列表和观看历史)
                    // const result2 = await VideoListApi.getVideoListId(userResult.result.uuid);
                    // if (result2.code === 0 && result2.successful) {
                    //   setItemWithExpiration("listId", result2.result, ApiCachedSecondsRandom);
                    //   // console.log("用户:", getItemWithExpiration("user"));
                    //   // console.log("视频列表:", getItemWithExpiration("listId"));
                    // } else {
                    //   Toast.show(t("login.index.863806-3"));
                    // }
                    navigate("/one/home");
                  } else {
                    Toast.show("{t('login.index.863806-4')} " + userResult.msg);
                  }
                };
                fetchUser(user);
              },
              isConsole: false,
              isLogin: isLogin,
              toggleIsLogin: toggleIsLogin,
              regSuccess: regSuccess,
              setRegSuccess: setRegSuccess,
            })}
          />
        </div>
        <Slogan />
      </div>
    </>
  );
}
